// Wave 3 silent-failure guard. Throws on any non-ok callApi response so the
// surrounding try/catch can surface the failure to the user. Keeps the bug-
// class fix declarative — `await assertApiOk(callApi(...))` is shorter than
// the open-coded `if (!res?.ok) throw new Error(res?.error || '...')` and is
// directly unit-testable.
export default async function assertApiOk(callApiPromise, fallbackMessage = 'Request failed') {
    const res = await callApiPromise;
    if (!res?.ok) {
        throw new Error(res?.error || res?.data?.detail || fallbackMessage);
    }
    return res;
}
